"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/Card-Program.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Image_template = require("../../components/Image/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Image_tag = marko_loadTag(Image_template),
    Locale_template = require("../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    Price_template = require("../../components/Price/index.marko"),
    Price_tag = marko_loadTag(Price_template),
    DifficultyLevel_template = require("./DifficultyLevel.marko"),
    DifficultyLevel_tag = marko_loadTag(DifficultyLevel_template),
    Button_template = require("../../components/Button/index.marko"),
    Button_tag = marko_loadTag(Button_template),
    WSAdapt_template = require("../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    marko_attrs0 = {
        "class": "card program-card item"
      },
    marko_attrs1 = {
        "class": "card-body"
      },
    marko_attrs2 = {
        "class": "strong primary pb-3"
      },
    marko_attrs3 = {
        "class": "card-title overflow-hidden"
      },
    marko_attrs4 = {
        "class": "card-bottom"
      },
    marko_attrs5 = {
        "class": "row blue-grey-text"
      },
    marko_attrs6 = {
        "class": "col-2 card-like"
      },
    marko_attrs7 = {
        "class": "col right-align"
      },
    marko_attrs8 = {
        "class": "position-absolute top-0 left-0 m-1"
      },
    marko_attrs9 = {
        "class": "badge badge-primary"
      },
    marko_attrs10 = {
        "class": "card-price float-right"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("537128"),
    marko_node0 = marko_createElement("i", {
        "class": "bx bx-purchase-tag-alt"
      }, "12", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs11 = {
        "class": "d-inline-block mr-2"
      },
    marko_node1 = marko_createElement("i", {
        "class": "bx bxs-bookmark-star float-left pt-2"
      }, "24", null, 0, 0, {
        i: marko_const_nextId()
      });

function render(input, out, __component, component, state) {
  var data = input;

  WSAdapt_tag({
      ns: "col-xl-3 col-lg-4 col-sm-6",
      qs: "col-xl-4 col-lg-6",
      hs: "col-lg-6",
      renderBody: function(out) {
        out.be("div", marko_attrs0, "1", component);

        out.be("div", {
            "class": "card-content",
            title: input.name
          }, "2", component);

        route_link_tag({
            href: "/program/" + input.programId,
            renderBody: function(out) {
              Image_tag({
                  alt: input.name,
                  class: "card-img-top img-fluid",
                  src: input.poster
                }, out, __component, "4");

              out.be("div", marko_attrs8, "5", component);

              out.be("span", marko_attrs9, "6", component);

              Locale_tag({
                  text: "Program"
                }, out, __component, "7");

              out.ee();

              out.ee();
            }
          }, out, __component, "3");

        out.be("div", marko_attrs1, "8", component);

        out.be("p", marko_attrs2, "9", component);

        const courseLen = input.outlines.length

        if (courseLen) {
          out.e("span", null, "10", component, 2)
            .t(courseLen, component)
            .t(" Courses");
        }

        if (input.price) {
          out.be("span", marko_attrs10, "11", component);

          out.n(marko_node0, component);

          Price_tag({
              amount: input.price.amount,
              currency: input.price.currency
            }, out, __component, "13");

          out.ee();
        } else {}

        out.ee();

        if (input.difficultyLevel) {
          DifficultyLevel_tag({
              type: input.difficultyLevel
            }, out, __component, "14");
        }

        out.be("h4", marko_attrs3, "15", component);

        route_link_tag({
            class: "theme-color",
            href: "/program/" + input.programId,
            renderBody: function(out) {
              Locale_tag({
                  text: input.name,
                  class: "theme-color"
                }, out, __component, "17");
            }
          }, out, __component, "16");

        out.ee();

        out.ee();

        out.be("div", marko_attrs4, "18", component);

        out.be("div", marko_attrs5, "19", component);

        out.be("div", marko_attrs6, "20", component);

        Button_tag({
            icon: "bx-heart",
            activeIcon: "bx-heart",
            class: "mr-3 font-medium-5",
            activeClass: "mr-3 font-medium-5 text-primary"
          }, out, __component, "21");

        out.ee();

        out.be("div", marko_attrs7, "22", component);

        if (input.points) {
          out.be("span", marko_attrs11, "23", component);

          out.n(marko_node1, component);

          out.t(input.points, component);

          out.t(" ");

          Locale_tag({
              text: "Points"
            }, out, __component, "25");

          out.ee();
        }

        out.ee();

        out.ee();

        out.ee();

        out.ee();

        out.ee();
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
